<script setup lang="ts">
/**
 * B32204 AGM with Audited Financial Statements — SG 공통 프리셋 **스튜디오** 패널(템플릿 문서 재현).
 *   공통 패널 AgmStudioPanelBase 에 이 프리셋 설정(AGM_AFS_STUDIO)만 꽂는다. 모델·변수 변환·문서 생성은 기존 함수 그대로라
 *   생성 문서 / TASK_DATA / Edit 스냅샷 형식은 예전 폼 패널과 같다. (호스트 props·이벤트는 그대로 통과)
 */
import { ref } from 'vue';
import type { OfficerDetail } from '@/features/AI-documents/types/docGen.types';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import AgmStudioPanelBase from '@/features/startTask/preset_task/sg/components/agm/studio/AgmStudioPanelBase.vue';
import { AGM_AFS_STUDIO } from '@/features/startTask/preset_task/sg/components/agm/studio/agmStudioConfigs';

const props = defineProps<{
  selection: PreSetSelection;
  entityData: Record<string, any> | null;
  taskTitle: string;
  isReady: boolean;
  currentStep: string;
  selectedPerson?: OfficerDetail | null;
  activePersonContext?: Record<string, any> | null;
  selectedAddress?: { value: string; type: string; position?: string } | null;
  activeAddressContext?: Record<string, any> | null;
  editTaskId?: number | null;
  studio?: boolean;
}>();
// 이벤트 리스너($attrs)를 명시적으로 넘기므로 자동 상속은 끈다(이벤트 리스너 중복 방지).
defineOptions({ inheritAttrs: false });
const base = ref<InstanceType<typeof AgmStudioPanelBase> | null>(null);
defineExpose({
  gatherState: () => base.value?.gatherState() ?? {},
  restoreState: (s: Record<string, any> | null | undefined) => base.value?.restoreState(s),
  createTask: () => base.value?.createTask(),
});
</script>

<template>
  <AgmStudioPanelBase ref="base" :config="AGM_AFS_STUDIO" v-bind="{ ...props, ...$attrs }" />
</template>
